import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=63919789&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63919789')) {
      api.createRecord('63919789', component.options)
    } else {
      api.reload('63919789', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=63919789&", function () {
      api.rerender('63919789', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/authentication/views/Login.vue"
export default component.exports